import { useState, useCallback } from "react";
import firebaseService from "../../../firebase_service/firebaseService";

interface UsePlayKlydosProps {
  deviceIds: string[];
}

const usePlayKlydos = ({ deviceIds }: UsePlayKlydosProps) => {
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const playKlydos = useCallback(
    async (klydoIds: string[]): Promise<boolean> => {
      if (klydoIds.length === 0 || deviceIds.length === 0) {
        setError("No klydos or devices selected");
        return false;
      }

      setIsSending(true);
      setError(null);

      try {
        const playKlydoId = firebaseService.genFbID();
        await firebaseService.sendCommandToClocksByBatch({
          id: playKlydoId,
          name: "playKlydo",
          local: false,
          devices: deviceIds,
          date: new Date(),
          params: klydoIds,
        });

        setIsSending(false);
        return true;
      } catch (err) {
        console.error("Error playing klydos:", err);
        setError(
          `Failed to play klydos: ${err instanceof Error ? err.message : "Unknown error"}`,
        );
        setIsSending(false);
        return false;
      }
    },
    [deviceIds],
  );

  const reset = useCallback(() => {
    setIsSending(false);
    setError(null);
  }, []);

  return {
    playKlydos,
    isSending,
    error,
    reset,
  };
};

export default usePlayKlydos;
